<template>
  <section aria-label="Configuration" id="config" class="config-wrapper">
    <InlineNavigation nav-id="config-groups" label="Config Groups" :tabs="tabs" :change="updateTab" :active-tab="activeTab" />
      <div class="config-wrapper">
        <General :config="config" :class="{active: activeTab===0}"/>
        <SearchBox :config="config" :class="{active: activeTab===1}"/>
        <SearchSuggestions :config="config" :class="{active: activeTab===2}"/>
        <SearchResults :config="config" :class="{active: activeTab===3}"/>
        <Filters :config="config" :class="{active: activeTab===4}"/>
        <Navigation :config="config" :class="{active: activeTab===5}"/>
      </div>
    </section>
</template>

<script>
import Presets from "./configuration/Presets";
import General from "./configuration/General";
import SearchBox from "./configuration/SearchBox";
import SearchSuggestions from "./configuration/SearchSuggestions";
import SearchResults from "./configuration/SearchResults";
import Navigation from "./configuration/Navigation";
import Filters from "./configuration/Filters";
import InlineNavigation from "./InlineNavigation";

export default {
  name: "Configuration",
  components: {
    Presets,
    General,
    SearchBox,
    SearchSuggestions,
    SearchResults,
    Navigation,
    InlineNavigation,
    Filters
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        
      ]
    };
  },
  methods: {
    updateTab(idx) {
      this.activeTab = idx;
        var e = undefined;
        if (window.CustomEvent) {
          try{
            e = new CustomEvent("closeColorPicker");
          }catch(ex){
          }
        } 
        if(e===undefined) {
          e = this.contentDocument.createEvent('CustomEvent');
          e.initCustomEvent("closeColorPicker", true, true, {});
        }
        window.dispatchEvent(e);

      let demo = "NONE";
      if (idx === 0 || idx >= 3 || (idx===1 && this.config.results.fullScreenConfig!==undefined)) {
        demo = "SERP";
      } else if (idx === 2) {
        demo = "SUGGEST";
      }
      this.$root.demo = demo;
    }
  },
  mounted() {
    this.tabs = [
        this.texts.menu.general,
        this.texts.menu.searchBox,
        this.texts.menu.suggestions,
        this.texts.menu.results,
        this.texts.menu.filters,
        this.texts.menu.navigation
    ];
  }
};
</script>

<style>
#config {
  display: flex;
  flex-direction: column;
}
.config-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1;
}

@media(max-width: 1699px){
  .config-wrapper {
    flex: none;
  }
}

.config-group {
  display: none;
  flex-direction: row;
  margin-top: 1em;
  width: 100%;
}

.config-group.active {
  display: flex;
  justify-content: center;
  padding: 1em 0 2em 0;
}

.config-group .column {
  display: flex;
  flex-direction: column;
  padding: 0 1em;
  align-items: center;
  box-sizing: content-box;
}

.config-group select {
  font-size: 1em;
  margin-bottom: 1em;
  width: 100%;
  padding: 0.5em;
}

#app input[type="text"],
#app input[type="number"] {
  padding: 0.25em 0.5em;
  font-size: 1em;
}

@media(max-width: 1699px){
  .config-group .column {
    flex: 1;
  }
}

.config-group .colors {
  flex: 2;
}

.config-group .column.colors div.grid {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 1em;
}

.config-group input[type="number"], .config-group input[type="text"] {
    width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Configuration.vue